import BaseComponent from './base.type';

export const enum TimeSlotStatus {
  AVAILABLE = 'available',
  BLOCKED = 'blocked',
  ASKING_SAME_DAY = 'asking_same_day',
  ASKING_NEXT_DAY = 'asking_next_day',
}
type CustomDisplayTime = {
  enabled: boolean;
  from?: string; // HH:mm
  to?: string; // HH:mm
};
type Attributes = {
  styles: {
    availableColor: string;
    notAvailableColor: string;
    holidayColor: string;
    saturdayColor: string;
    enabled: boolean;
    dayWidth: number;
  };
  navigation: {
    defDate: string; // '2024-10-22';
    minDate: string; // '2019-01-01';
    maxDate: string; // '2045-01-01';
  };
  opacity: number;
  backgroundColor: string;
  timeDuration: '15' | '30' | '45' | '60' | '90';
  dayViewNumber: '3days' | '4days' | '5days' | '7days' | '1month';
  customInitializeTime: {
    enabled: boolean;
    hour?: number;
    minute?: number;
  };
  customAskingTimeSameDay: {
    color: string;
    fontFamily: string;
    fontSize: number;
  };
  customAskingTimeNextDay: {
    color: string;
    fontFamily: string;
    fontSize: number;
  };
  customMondayTime: CustomDisplayTime;
  customTuesdayTime: CustomDisplayTime;
  customWednesdayTime: CustomDisplayTime;
  customThursdayTime: CustomDisplayTime;
  customFridayTime: CustomDisplayTime;
  customSaturdayTime: CustomDisplayTime;
  customSundayTime: CustomDisplayTime;
  borderColor: string;
  borderStyle: 'dashed';
  borderWidth: number;
  fontFamily: string;
  fontSize: number;
  fontWeight: string;
  lineHeight: number;
  color: string;
  initializeList: boolean;
  items: any[];
  successActions?: { actionId: string };
  failedActions?: { actionId: string };
  askingActions?: { actionId: string };
};

export type ITimeSlot = BaseComponent & {
  attributes: Attributes;
  componentData: Record<string, any>;
  record: Record<string, any>;
  initId: string;
  dataBinding: any;
};

export type TimeSlotBindingItemType = {
  id: string; // 'caa9497ec6ce';
  blockStartTime: string; // '2024/10/01 01:40 PM';
  blockEndTime: string; // '2024/10/01 01:40 PM';
  'stockConfig.stockUsedCount'?: string; // number
  createdAt: string; // '2024-10-22T04:40:27.273Z';
  updatedAt: string; // '2024-10-22T04:40:27.273Z';
};
export type TimeSlotBindingItemTypeFormatted = {
  id: string;
  createdAt: Date;
  blockStartTime: Date;
  blockEndTime: Date;
  stockUsedCount: number;
  updatedAt: Date;
};
export type TimeSlotItemDisplay = {
  eventStarttime: Date;
  availableStock: number;
  status: TimeSlotStatus;
};
